module.exports = __webpack_public_path__ + "img/Web_order_hit02.dcd66738.png";